var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_2639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.43986 6.49663L8.80936 9.85879L12.1789 6.49663L13.2139 7.5317L8.80936 11.9363L4.40479 7.5317L5.43986 6.49663Z",
    fill: "#E9E9E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_2639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6183,
    height: 17.6183,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 17.8091)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionIcon);
export default __webpack_public_path__ + "static/media/accordionIcon.6d0a877d5e7308fc6cae60a269aa290d.svg";
export { ForwardRef as ReactComponent };